import axios from 'axios'
import { METHOD } from './constant'
import { getUserToken } from '@/utils/auth'

export const apiGetNonAuth = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params
})

export const apiPostNonAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.POST,
  data
})

export const apiPutNonAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PUT,
  data
})

export const apiGetAuth = (URL, params, signal) => axios({
  url: URL,
  method: METHOD.GET,
  params,
  headers: {
    Authorization: getUserToken()
  },
  ...(signal && { signal })
})

export const apiGetPdfAuth = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params,
  headers: {
    Authorization: getUserToken()
  },
  responseType: 'arraybuffer',
  dataType: 'blob'
})

export const apiPostAuth = (URL, data, timeout) => axios({
  url: URL,
  method: METHOD.POST,
  data,
  headers: {
    Authorization: getUserToken()
  },
  ...(timeout && { timeout })
})

export const apiPutAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PUT,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiPatchAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.PATCH,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiDeleteAuth = (URL, data) => axios({
  url: URL,
  method: METHOD.DELETE,
  data,
  headers: {
    Authorization: getUserToken()
  }
})

export const apiPostAuthWithCustomHeadersResponseType = (URL, params) => axios({
  url: URL,
  method: METHOD.POST,
  params,
  headers: {
    "Content-Type": "application/octet-stream",
    Authorization: getUserToken()
  },
  responseType: 'arraybuffer'
})

export const apiGetExcelAuth = (URL, params) => axios({
  url: URL,
  method: METHOD.GET,
  params,
  headers: {
    Authorization: getUserToken()
  },
  responseType: 'arraybuffer'
})
